import { createSelector } from '@ngrx/store';
import { selectAuditing } from '../auditing.selectors';

export const selectTasksState = createSelector(selectAuditing, state => state.tasks);

export const selectLoadingAssignedTasks = createSelector(selectTasksState, state => state.loadingAssignedTasks);
export const selectLoadingAvailableTasks = createSelector(selectTasksState, state => state.loadingAvailableTasks);
export const selectLoadingAuditorState = createSelector(selectTasksState, state => state.loadingAuditorState);

/** Null while the available tasks are still on their way, so the empty-queue prompt cannot flash. */
export const selectAvailableGroupsCount = createSelector(selectTasksState, state =>
  state.loadingAvailableTasks ? null : state.availableTasks.slice(0, state.loadedAvailableTasks).length,
);
export const selectError = createSelector(selectTasksState, state => state.error);
export const selectActionError = createSelector(selectTasksState, state => state.actionError);

export const selectTasks = createSelector(selectTasksState, state => state.tasks);
export const selectLoadedAvailableTasks = createSelector(selectTasksState, state =>
  state.availableTasks.slice(0, state.loadedAvailableTasks),
);
export const selectIsThereMoreAvailableTasks = createSelector(
  selectTasksState,
  state => state.loadedAvailableTasks < state.availableTasks.length,
);

export const selectShouldNotify = createSelector(selectTasksState, state => state.shouldNotify);
export const selectTakingTaskIds = createSelector(selectTasksState, state => state.takingTaskIds);
export const selectIsAuditorReady = createSelector(selectTasksState, state => state.isAuditorReady);
export const selectAuditedFlagged = createSelector(selectTasksState, state => state.auditedFlagged);
export const selectRequiredFlagged = createSelector(selectTasksState, state => state.requiredFlagged);
